.text-input-form-field{width:100%}.text-input-icon{padding:0 6px 0 0!important}
/*# sourceMappingURL=text-input.component-DWLOVSUC.css.map */
